<script setup>
import { onMounted, ref } from 'vue'
import { api } from '../services/api'
import ContentTransferPanel from '../components/ContentTransferPanel.vue'

const subjects = ref(null)
const error = ref('')

async function load() {
  try { subjects.value = (await api('/admin/overview')).subjects; error.value = '' }
  catch (err) { error.value = err.message }
}

onMounted(load)
</script>

<template>
  <header><p class="eyebrow">Học liệu theo môn</p><h1 class="page-title">Nhập / xuất học liệu</h1><p class="page-subtitle">Chuyển bài giảng, ví dụ, câu hỏi và đề của từng môn giữa các máy chủ. Tài khoản, tiến độ và điểm không nằm trong file.</p></header>
  <div v-if="error" class="error-banner" style="margin-top:20px">{{ error }} <button class="btn btn-light" @click="load">Thử lại</button></div>
  <div v-if="!subjects && !error" class="loading-block"><div><div class="loader"></div><p>Đang tải danh sách môn…</p></div></div>
  <ContentTransferPanel v-else-if="subjects" :subjects="subjects" @imported="load" />
</template>
